import React from "react";
import styles from "../../styles/components/ui/Button.module.css";


function Button({ 
  label, 
  onClick, 
  type = "button", 
  variant = "primary",
  disabled = false 
}) {
  return (
    <button 
      type={type} 
      onClick={onClick} 
      className={`${styles.button} ${styles[variant]}`}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export default Button;